import { FC } from 'react';
import { Divider, MenuItem, Typography } from '@mui/material';
import { RowStack } from 'components/styled';
import { StyledPaginationButton, StyledPaginationButtonOtherStyle, StyledPaginationWrapper, StyledSelectMenu } from 'components/Pagination/styled';
import { PaginationProps } from 'components/Pagination/types';
import { hitsPerPageOptions } from 'components/Pagination/constants';
import { KeyboardArrowRight } from '@mui/icons-material';
import { usePagination } from '@mui/lab';
import { bgWeak, textSecondary } from 'themes/colors';
import { KeyboardArrowLeft } from '@mui/icons-material';
import './index.css';

const Pagination: FC<PaginationProps> = ({ handlePaginationChange, hitsPerPage, page, totalPages, style }) => {
  const { items } = usePagination({
    count: totalPages,
    defaultPage: page,
    page: page,
    onChange: (_event, value) => {
      console.log('onchange', value);
      handlePaginationChange({ page: value, pageSize: hitsPerPage });
    },
  });

  if (style === 'label_pages_count') {
    return (
      <RowStack fullWidth justifyContent={'space-between'} alignItems={'center'} padding={'12px'} gap={'8px'}>
        {/* Hits per page */}
        <Typography typography='paragraphSmall' color={textSecondary}>
          Page {page} of {totalPages}
        </Typography>

        {/* Pages */}
        <RowStack gap={'8px'} alignItems={'center'}>
          {items.map(({ page, type, selected, ...item }, index) => {
            let children = null;

            if (type === 'start-ellipsis' || type === 'end-ellipsis') {
              console.log('type', type);
              
              children = (
                <StyledPaginationButtonOtherStyle
                  padding='6px 14px'
                  backgroundColor={selected ? bgWeak : 'white'}
                  id={`${index}`}
                  onClick={items[type === 'end-ellipsis' ? index - 1 : index + 1].onClick}
                >
                  <Typography typography='labelSmall'>...</Typography>
                </StyledPaginationButtonOtherStyle>
              );
            } else if (type === 'page') {
              children = (
                <StyledPaginationButtonOtherStyle
                  padding='6px 14px'
                  backgroundColor={selected ? bgWeak : 'white'}
                  id={`${index}`}
                  {...item}
                >
                  <Typography typography='labelSmall'>{page}</Typography>
                </StyledPaginationButtonOtherStyle>
              );
            } 

            return children;
          })}
        </RowStack>

        <StyledSelectMenu
          onChange={(event) => {
            handlePaginationChange({ page: page, pageSize: Number(event.target.value) });
          }}
          value={hitsPerPage}
          data-test='pagination-page-size-menu'
          MenuProps={{
            PopoverClasses: {
              paper: 'custom-menu-popover',
            },
          }}
        >
          {hitsPerPageOptions.map((item) => (
            <MenuItem
              key={item.value}
              value={item.value}
              data-test={`pagination-page-size-item-${item.value}`}
              sx={{ padding: '4px 10px' }}
            >
              {item.label}
            </MenuItem>
          ))}
        </StyledSelectMenu>
      </RowStack>
    );
  }

  return (
    <RowStack fullWidth justifyContent={'space-between'} alignItems={'center'} padding={'12px'}>
      {/* Hits per page */}
      <RowStack gap={'8px'} alignItems={'center'}>
        <Typography typography='paragraphSmall'>Items per page:</Typography>
        <StyledSelectMenu
          onChange={(event) => {
            handlePaginationChange({ page: page, pageSize: Number(event.target.value) });
          }}
          value={hitsPerPage}
          data-test='pagination-page-size-menu'
          MenuProps={{
            PopoverClasses: {
              paper: 'custom-menu-popover',
            },
          }}
        >
          {hitsPerPageOptions.map((item) => (
            <MenuItem
              key={item.value}
              value={item.value}
              data-test={`pagination-page-size-item-${item.value}`}
              sx={{ padding: '4px 10px' }}
            >
              {item.label}
            </MenuItem>
          ))}
        </StyledSelectMenu>
      </RowStack>

      {/* Pages */}
      <StyledPaginationWrapper divider={<Divider flexItem orientation='vertical' />}>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;

          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = '…';
          } else if (type === 'page') {
            children = (
              <StyledPaginationButton
                padding='6px 14px'
                backgroundColor={selected ? bgWeak : 'white'}
                id={`${index}`}
                {...item}
              >
                <Typography typography='paragraphSmall'>{page}</Typography>
              </StyledPaginationButton>
            );
          } else {
            children = (
              <StyledPaginationButton padding='6px' id={`${index}`} {...item}>
                {type === 'previous' ? (
                  <KeyboardArrowLeft sx={{ height: '20px', width: '20px' }} />
                ) : (
                  <KeyboardArrowRight sx={{ height: '20px', width: '20px' }} />
                )}
              </StyledPaginationButton>
            );
          }

          return children;
        })}
      </StyledPaginationWrapper>
    </RowStack>
  );
};

export default Pagination;
